import React from 'react';
import { useTranslation } from 'react-i18next';
import './QCCell.scss';

export enum QCCellEnum {
  passed = 'orderDetail_qc_status_pass',
  failed = 'orderDetail_qc_status_fail',
  cancelled = 'orderDetail_qc_status_cancelled',
  pending = 'orderDetail_qc_status_pending',
}

export type QCStatusTypes = 'Passed' | 'Failed' | 'Cancelled' | 'Pending';

interface IQCCell {
  status: QCStatusTypes;
}

export const QCCell: React.FC<IQCCell> = ({ status }) => {
  const { t } = useTranslation();

  let obj: {
    text: string;
    textClass: string[];
    img: undefined | string;
    imgClass: string;
  } = {
    text: '',
    textClass: ['text-uppercase'],
    img: undefined,
    imgClass: '',
  };

  switch (status) {
    case 'Passed':
      obj = {
        ...obj,
        text: t(QCCellEnum.passed),
        img: 'fa-check-circle',
        imgClass: 'pass',
      };
      break;
    case 'Failed':
      obj = {
        ...obj,
        text: t(QCCellEnum.failed),
        img: 'fa-times-circle',
        imgClass: 'fail',
      };

      break;
    case 'Cancelled':
      obj = {
        ...obj,
        text: t(QCCellEnum.cancelled),
        // img: 'fa-times-circle',
      };
      break;
    case 'Pending':
      obj = {
        ...obj,
        text: t(QCCellEnum.pending),
        textClass: [...obj.textClass, 'font-italic'],
      };
      break;
  }
  return (
    <td>
      {obj.img && (
        <span className={`order-detail-qc-icon mr-1 ${obj.imgClass}`}>
          <i className={`fas ${obj.img}`}></i>
        </span>
      )}
      <span className={obj.textClass.join(' ')}>{obj.text}</span>
    </td>
  );
};
